export default function QuestionMark() {
  return (
    <svg
      className="fill-current w-4 h-4 md:w-6 md:h-6"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.75 12C0.75 14.9837 1.93526 17.8452 4.04505 19.955C6.15483 22.0647 9.01631 23.25 12 23.25C14.9837 23.25 17.8452 22.0647 19.955 19.955C22.0647 17.8452 23.25 14.9837 23.25 12C23.25 9.01631 22.0647 6.15483 19.955 4.04505C17.8452 1.93526 14.9837 0.75 12 0.75C9.01631 0.75 6.15483 1.93526 4.04505 4.04505C1.93526 6.15483 0.75 9.01631 0.75 12V12Z"
        className="fill-current"
      />
      <path
        d="M9 8.99943C9.00011 8.44946 9.15139 7.9101 9.43732 7.4403C9.72325 6.9705 10.1328 6.58833 10.6213 6.33558C11.1097 6.08283 11.6583 5.96921 12.2069 6.00715C12.7556 6.04508 13.2833 6.23311 13.7323 6.55068C14.1813 6.86825 14.5344 7.30314 14.7529 7.80782C14.9715 8.3125 15.0471 8.86755 14.9715 9.4123C14.8959 9.95705 14.6721 10.4705 14.3244 10.8967C13.9767 11.3228 13.5185 11.6451 13 11.8284C12.7074 11.9319 12.4541 12.1235 12.275 12.3769C12.0959 12.6304 11.9998 12.9331 12 13.2434V14.2494"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17.25C11.9258 17.25 11.8533 17.272 11.7917 17.3132C11.73 17.3544 11.6819 17.413 11.6535 17.4815C11.6252 17.55 11.6177 17.6254 11.6322 17.6982C11.6467 17.7709 11.6824 17.8377 11.7348 17.8902C11.7873 17.9426 11.8541 17.9783 11.9268 17.9928C11.9996 18.0073 12.075 17.9998 12.1435 17.9715C12.212 17.9431 12.2706 17.895 12.3118 17.8333C12.353 17.7717 12.375 17.6992 12.375 17.625C12.375 17.5255 12.3355 17.4302 12.2652 17.3598C12.1948 17.2895 12.0995 17.25 12 17.25Z"
        fill="white"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
